import { useCallback, useEffect, useState } from "react";

import { type ParticipantInfo } from "./useAIChat";

const LOCAL_STORAGE_KEY = "ai_tutor_preferences";

interface AITutorPreferences extends ParticipantInfo {
  mode?: "practice" | "interactive"; // Add mode to preferences
}

const defaultPreferences: AITutorPreferences = {
  gradeLevel: "5",
  mode: "practice",
  subject: "reading",
};

export function useAITutorPreferences() {
  const [preferences, setPreferences] = useState<AITutorPreferences>(() => {
    try {
      const savedPrefs = localStorage.getItem(LOCAL_STORAGE_KEY);
      return savedPrefs ? JSON.parse(savedPrefs) : defaultPreferences;
    } catch (error) {
      console.error("Error loading AI tutor preferences:", error);
      return defaultPreferences;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(preferences));
    } catch (error) {
      console.error("Error saving AI tutor preferences:", error);
    }
  }, [preferences]);

  const updatePreferences = useCallback((newPreferences: Partial<AITutorPreferences>) => {
    setPreferences((prev) => ({ ...prev, ...newPreferences }));
  }, []);

  return {
    preferences,
    updatePreferences,
  };
}
